export default {
  "pagina-inicial": "Main page",
  "painel": "Dashboard",
  "editar-operacao": "Edit operation",
  ajuda: "Help",
  entrar: "Login",
  senha: "Password",
  informe: "Provide",
  nome: "Name",
  "data-cadastro": "Register date",
  "cadastro": "Sign up",
  "atualizar-cadastro" : "Update",
  "editar-cadastro":"Edit User Registration",
  "alterar-senha": "Change User Password",
  "cadastre-se": "Sign up",
  "cadastrar": "Submit",
  "cadastro-validado" : "Registration Validated",
  "cadastro-beta-ativo" : "Registration Active Beta",
  "cadastro-ativo" : "Active Registration",
  "administrador": "Administrator",
  "user-tempo": "Access Period",
  "usuario-nao-beta" : "The user is not a BetaUser, register!",
  "user-tempo-inicio": "Start of Period",
  "user-tempo-final": "End of Period",
  "cadastro-sucesso":
    "Sign up successful. Check your inbox for a verification link.",
  "redefinir-senha": "Password Reset",
  "senhas-diferentes": "Passwords do not match",
  "confirma-senha": "Password confirmation",
  "verifique-seu-email": "Check your inbox",
  "senha-redefinida-sucesso": "Password successfully reset",
  enviar: "Send",
  voltar: "Back",
  "email-invalido": "The e-mail address is invalid",
  "cpf-invalido": "CPF is invalid",
  "erro-api": "Something went wrong. Please try again.",
  "erro-estimativa-valor":
    "Error while estimating the value of the analysis. Please try again",
  "selecionar-todos": "Select All",
  "expandir-todos": "Expand All",
  "ocultar-todos": "Collapse All",
  "Uso-Especifico": "{num, plural, one {Specific use} other {Specific uses}}",
  "atividades-economicas":
    "Economic activities",
  "ajuda-analise-atividades-economicas":
    "MCR 2-9-3: Rural credit will not be granted for enterprises located on rural properties wholly or partially located in a Conservation Unit, as long as they are registered in the National Registry of Conservation Units (CNUC) of the Ministry of Environment and Climate Change ( MMA), unless the economic activity is in compliance with the Conservation Unit Management Plan",
  "valor-base": "Base Value",
  "validacao-nome": "You need to insert a name for the operation",
  "ocorreram-erros": "Some errors occurred",
  "vincular-operacao": "Link to operation",
  "cadastre-car-para-ver": "Insert a CAR to visualize it on the map",
  "selecione-car-para-ver": "Select a CAR to visualize it",
  "cadastre-selecione-gleba-para-ver":
    "Insert/Select an area to visualize it on the map",
  "subtotal-area": "Area Subtotal",
  "subtotal-documentos": "Document Subtotal",
  desconto: "Discount",
  "cadastro-car": "CAR registration",
  total: "Total",
  "executar-analise-erro": "Error creating report. Please try again.",
  "executar-analise-sucesso": "Report successfully created!",
  "detalhes-consulta": "Report details:",
  municipio: "Municipality",
  area: "Area",
  "area-ha": "Area (ha)",
  "area-consultada": "Queried Area",
  legenda: "Legend",
  glebas: "Tracts",
  "Documento-Proponentes-Participantes": "Proponents/Participants CPF/CNPJ",
  Documento: "{num, plural, one {CPF/CNPJ} other {CPF/CNPJ}}",
  criterios: "Criteria",
  "ajuda-criterios-1":
    "According the data provided, we have selected available criteria for analysis.",
  "ajuda-criterios-2":
    "You must select at least one criterion for analysis. To the right of each criterion, you can see the price by hectare or document.",
  "ajuda-criterios-3":
    "Below the criteria list, you can find the total value by hectare and document for this report, as well as the total value of the report.",
  "nome-consulta": "Report Name",
  "nome-operacao": "Operation Name",
  "codigo-consulta": "Report Code",
  "ajuda-nome-consulta": "Optionally, you can provide a name for your report.",
  "ajuda-nome-operacao": "You can provide a name for your operation.",
  "ajuda-area-nao-cultivada":
    "You can add the area that will not be used for cultivation",
  Executar: "Execute",
  Salvar: "Save",
  "salvar-descricao": "Save description",
  "ajuda-salvar-operacao-1": "To save the operation, select",
  "ajuda-executar-analise-1": "To create a single report, you can select ",
  "ajuda-executar-analise-2":
    "If you want to generate multiple reports and execute them all at once, you can save this report.",
  "erro-inesperado-upload":
    "Unexpected error while uploading file. Please check your file and try again.",
  "mensagem-input-operacao":
    "Provide the documents and the operation informations.",
  "mensagem-input-analise":
    "Provide the documents and/or area file to base the report on. The price for each report is {analysisBudget}.",
  "mensagem-input-analise-empresarial":
    "Provide the documents and/or area file to base the report on.",
  "relatorios-empresariais": "Reports",
  "filtrar-por-usuario": "Filter by user",
  "selecione-um-ou-mais": "Select one or more",
  "selecione-um": "Select one",
  "solicitante-consulta": "Requester",
  "procure-por-nome": "Search by name",
  "mensagem-intro-video": "Learn how to use BusCAR",
  "titulo-intro-video": "How to use BusCAR",
  "erro-documento-invalido":
    "We could not validate the following {num, plural, one {document} other {documents}}",
  "ajuda-analise-documento":
    "You can add multiple CPFs and CNPJs. If you already have a list, you can copy and paste the values separated by comma or semicolon",
  "e-ou": "and/or",
  Enviando: "Uploading",
  "adicionar-arquivo": "Add File",
  "aceitamos-formatos": "We accept files in the following formats:",
  "baixar-template": "Download Template",
  "formato-shapefile": "Shapefile, zipped ({link})",
  "formato-kml": "Kml ({link})",
  "formato-sicar":
    "{link}, zipped (SICAR is the CAR - Cadastro Ambiental Rural/Rural Ambiental Cadaster - system of the Serviço Florestal Brasileiro - Brazilian Florestal Service)",
  "um-arquivo-por-consulta": "You can only upload one file per report.",
  continuar: "Continue",
  "erro-verificar-saldo":
    "Error while verifying available balance. Please try again.",
  "saldo-insuficiente": "Insufficient balance to execute the report.",
  "nao-encontrado": "Not Found",
  "nao-encontrado-mensagem": "We could not find the page you are looking for.",
  "tente-voltar": "Try going back to the ",
  "pagina-login": "login page",
  "remover-arquivo": "Remove File",
  "resultado-consulta": "Analysis Results",
  "resultado-operacao": "Operation Results",
  "cars-detectados": "Detected CARs",
  "nenhum-car-encontrado": "No CAR found",
  "data-base": "Criterion Date",
  "data-consulta": "Report Date",
  "data-operacao": "Operation Date",
  "data-modificacao": "Modified Date",
  "ultima-atualizacao": "Last Update",
  "ordernar": "Order by",
  valor: "Price",
  "mudancas-termos": "Updates to our Terms and Privacy Policy.",
  "mudancas-termos-descricao":
    "The terms are being updated to better suit the new LGPD (General Data Protection Law). To continue using our system, you will need your consent to the new terms and policies.",
  "nenhuma-infracao": "No overlap found",
  "infracoes-encontradas": "Overlap found",
  "porcentagem-sobreposicao": "Overlap percentage",
  "bioma": "Biome",
  "nenhuma-infracao-documento": "No occurrences found",
  "x-ocorrencias-encontradas": "{num} occurrence(s) found",
  "cpfs-com-dap": "CPFs with DAP",
  "sem-titulo": "Untitled",
  "sem-contrato": "No contract",
  "sem-referencia-bacen": "No BACEN Reference",
  "sem-documento": "No documents",
  "area-intersecao": "Overlapping Area",
  "area-gleba-fora-do-perimetro-do-car": "Land area outside the perimeter of the car",
  "documentos-com-problemas": "CPFs",
  "documentos-sem-problemas": "CPFs without occurrences",
  descricao: "Description",
  "ajuda-descricao": "Optionally, you can also provide a description.",
  fonte: "Source",
  "mensagem-processando-consulta":
    "Your analysis is still being processed. Some criteria may take up to a few hours to process.",
  "tipos-criterio": "Criteria Types",
  contrato: "Contract number",
  "referencia-bacen": "BACEN Reference",
  "ajuda-referencia-bacen": "You can provide a BACEN reference number.",
  "ajuda-contrato": "You can provide a contract number.",
  "validacao-referencia-bacen": "You need to insert a BACEN reference number.",
  "validacao-contrato": "You need to insert a contract number",
  "resolver-captcha": "Solve the captcha",
  "pagina-anterior": "Previous Page",
  "proxima-pagina": "Next Page",
  "nenhuma-consulta-encontrada": "No reports found",
  "nenhuma-operacao-encontrada": "No operations found",
  historico: "History",
  operacao: "Operations",
  "nova-consulta": "New Analysis",
  "nova-operacao": "New Operation",
  "area-nao-cultivada": "Uncultivated Area",
  sobre: "About",
  "termos-uso": "Terms of Use",
  "politica-privacidade": "Privacy Policy",
  contato: "Contact",
  sair: "Logout",
  "possui-criterio-documento": "has document criteria",
  "possui-criterio-area": "has area criteria",
  "li-e-aceito": "I have read and accept the",
  "e-a": "and the",
  "validar-conta": "Validate Account",
  "sucesso-validacao-email": "Successfully validated account",
  "erro-validacao-email": "There was a problem validating your account",
  sucesso: "Success",
  erro: "Error",
  "sera-cobrado": "You will be charged",
  "confirmacao-relatorio": "Report Confirmation",
  processada: "Processed",
  "nao-processada": "Not processed",
  sim: "Yes",
  nao: "No",
  cancelar: "Cancel",
  "executar-analise": "Execute Analysis",
  "executar-selecionadas": "Execute Selected",
  "executadas-sucesso":
    "{num} {num, plural, one {analysis} other {analyses}} successfully executed",
  "executadas-erro":
    "{num, plural, one {An error occurred while executing the analysis} other {{num} errors occurred while executing the analyses}}:",
  "exportar-como-pdf": "Export as PDF",
  "exportar-kml": "Export KML",
  "validacao-compliance": "Socioenvironmental Compliance Validation",
  "confirmar-relatorio-delecao": "Removal Confirmation",
  "confirmar-delecao": "Are you sure you want to remove this report?",
  "validacao-operacao": "Financed Area validation",
  "consultas-operacao": "Operation Reports",
  endereco: "Address",
  fone: "Phone",
  "mensagem-home-office-telefone": "We are working from home, call us at",
  "horario-atendimento": "Hours",
  "horario-atendimento-descricao": "from {de} to {ate}, Belem timezone (UTC-3)",
  "mensagem-sobre-1":
    "Terras Crédito Rural is a system that allows the presentation and socio-environmental analysis of rural credit proposals for Financial Institutions",
  "mensagem-sobre-2":
    "The system crosses different official databases and produces a compliance report in accordance with Brazilian rural credit legislation.",
  "mensagem-sobre-3":
    "This is done in a transparent, agile and simplified manner, generating greater security in the process of analyzing and approving rural credit for everyone involved.",
  "perguntas-frequentes": "Frequently Asked Questions",
  fechar: "Close",
  "ir-para-contato": "Go to the contact page.",
  todos: "All",
  personalizado: "Custom",
  "bases-disponiveis": "Available Bases",
  "usuarios-unicos": "Unique users",
  "usuarios-consultas": "Users with queries",
  consultas: "Total queries",
  "consultas-normais": "Normal queries",
  "consultas-empresariais": "Enterprise queries",
  "contas-antes-lancamento": "Accounts before launch",
  "contas-pos-lancamento": "Accounts post launch",
  "filtrar-por-data": "Filter by date",
  ate: "to",
  "todos-usuarios": "All users",
  "vincular-usuario-pj": "Link user to PJ",
  vincular: "Link",
  vinculado: "Linked",
  grafico: "Graph",
  usuarios: "Users",
  "entrou-em": "Signed up in",
  "numero-total-consultas": "Total queries made",
  "primeira-consulta": "First query",
  "ultima-consulta": "Last query",
  "numero-car": "CAR number",
  status: "Status",
  "area-car": "CAR area",
  "tipo-imovel": "Building type",
  "validacao-documentos": "You need to insert at least one CPF/CNPJ",
  "validacao-kml": "You need to insert a KML file",
  "sem-consulta": "No queries",
  "consultas-feitas": "Made queries",
  "consultas-restantes": "Remaining queries",
  "total-usuarios": "Total users linked",
  informacoes: "Informations",
  "conta-pj-master": "Master PJ account",
  "conta-pj-direta": "Direct PJ account",
  "plano-atual": "Actual plan",
  "dia-bilhetagem": "Ticketing day",
  "historico-consultas": "Queries history",
  "consultas-mensais": "monthly queries",
  tolerancia: "tolerance",
  "admin": "admin",
  "gestor": "Manager",
  "operacional": "Operational",
  "confirmacao-reenvio": "Resend Confirmation",
  "reenvio-email-usuario": "Resend confirmation email of user {email}",
  "exportar-coordenadas": "Coordinates in CSV",
  dias: "days",
  horas: "hours",
  minutos: "minutes",
  segundos: "segundos",
  alertas: "Alerts",
  "modulos-fiscais": "Tax modules",
  pronaf: "Pronaf",
  "ajuda-pronaf": "You can identify if the operation is Pronaf",
  identificador: "Identifier Code",
  "sem-identificador": "No identifier code",
  "cpf-cnpj": "CPF / CNPJ",
  "adicionar-gleba": "Add Tract",
  "cadastrar-gleba": "Register areas",
  "operacao-car-descricao":
    "Insert below every CAR that will be used in the operation",
  "cadastrar-car": "Register CAR",
  "lista-cars-cadastrados": "Registered CAR list",
  "lista-glebas-cadastradas": "Registered areas list",
  "nenhum-car-cadastrado":
    "You don't have any registered CAR yet. Click in the button Register CAR to continue",
  "nenhuma-gleba-cadastrada":
    "You don't have any registered areas yet. Click in the button Register areas to continue",
  carregando: "Loading",
  gleba: "Tract",
  "cancelar-desenho": "Cancel drawing",
  "operacao-gleba-car-descricao":
    "Select a CAR and click the button to add a tract. You can draw the tract using the tool available in the map, or you can import a .zip or .kml file",
  "operacao-gleba-descricao":
    "Insert all areas that will be analyzed in the operation",
  "aviso-adicionando-desenho":
    "Warning: you are adding a tract, draw in the map above.",
  "como-deseja-add-gleba": "How do you wish to add tract?",
  "desenhar-mapa": "Draw in the map",
  "fazer-upload-arquivo": "Upload a file",
  "fazer-upload-glebas": "Upload tracts file",
  "vinculacao-car": "CAR Linking",
  "car-vinculados": "Linked CAR",
  "car-nao-vinculados": "Unlinked CAR",
  "vinculacao-car-descricao":
    "List of overlapped CARs in operation areas. Click in the desired CAR and complete the captcha to link it.",
  "car-vinculados-selecione-abaixo": "Select a CAR below to see details",
  "car-nao-vinculados-selecione-abaixo":
    "Select a CAR below to see details and link",
  "sem-car-vinculados":
    "You don't yet have linked CARs. Select a CAR in thelist below to link",
  "detalhes-car-detectado": "Detected CAR details",
  "vincular-car": "Link CAR",
  "clique-captcha-para-vincular-car":
    "Click in the button below and complete the captcha to link the CAR",
  "gerando-captcha": "Generating captcha",
  desvincular: "Unlink",
  "sem-car-nao-vinculados": "You don't have a CAR that is not linked.",
  "glebas-identificadas-arquivo":
    "The following tracts were identified in the file. Select those you wish to add to this CAR",
  "dados-da-operacao": "Operation data",
  resultados: "Results",
  "bem-vindo-plataforma": "Welcome to the platform",
  "tempo-restante-sessao": "Session time remaining",
  "guias-uso": "Use guides",
  "desenvolvido-por": "Developed by",
  "cadastrar-produto-sicor": "Register SICOR product",
  "pesquise-caixa-abaixo": "Search in the box below and select a product",
  "pesquise-codigo-nome": "Search the product name or code",
  codigo: "Code",
  finalidade: "Goal",
  atividade: "Activity",
  modalidade: "Modality",
  variedade: "Variety",
  cesta: "Basket",
  zoneamento: "Zoning",
  consorcio: "Consortium",
  "digite-produto-acima-resultados":
    "Type the product in the box above to fetch the results",
  "detalhes-produto": "Product details",
  "data-inicio-plantio": "Planting start date",
  "data-fim-plantio": "Planting finishing date",
  "data-inicio-colheita": "Harvest start date",
  "data-fim-colheita": "Harvest finishing date",
  "remover-datas": "Remove dates",
  "adicionar-datas-opcional": "Add dates (optional)",
  "cadastrar-produto": "Register product",
  "produtos-sicor-cadastrados": "Registered SICOR products",
  "nenhum-produto-sicor-cadastrado":
    "No products registered, click in the button below to register",
  "etapa-anterior": "Previous step",
  "etapa-proximo": "Next step",
  "descricao-resultados":
    "In this area you can see the operation analysis results, and also export its data.",
  geral: "General",
  "descricao-geral-resultados": "Operation general results",
  "descricao-documento-resultados": "Operation CPF/CNPJ results, click to see.",
  "descricao-car-resultados": "Operation CAR results, click to see.",
  "descricao-gleba-resultados": "Operation area results, click to see.",
  "exportar-resultados": "Export Results",
  "exportar-json": "Export JSON",
  "detalhes-gleba": "Area details",
  "erro-captcha-fora-ar": "SICAR captcha generation unavailable at the moment.",
  "erro-captcha-errado":
    "Error while linking, verify if the captcha solution is correct",
  "saiba-se-car-utilizado": "Saiba se este CAR já foi utilizado em alguma operação no passado",
  "acoes": "Actions",
  "data": "Date"
};
